import React from 'react'
import { useState, useEffect } from 'react';
import { URL } from '../../Redux/common/url';


function Myservice() {
 const [productLists, setProductListt] = useState([]);
   
     useEffect(() => {
       fetchProductList();
     }, []);
   
     const fetchProductList = async () => {
       try {
         const response = await fetch(
           `${URL.API_BASE_URL}/publicApi/servicenewListPublic`
         );
         if (response.ok) {
           const data = await response.json();
           setProductListt(data?.servicenew); // Store the sliders in state
         }
         const data = await response.json();
         console.log(data);
       } catch (error) {
         console.error("Fetch error:", error);
       }
     };
  return (
    <div className='container-fluid'>
   
             <div className="row my-0 p-3 d-flex align-items-center my-4" >
            <div className='col-12 col-sm-12 col-md-6 mb-3'>
              <h5 className="card-title fw-bold text-danger ">Our Services____</h5>
              <h1 className="card-title fw-bold mt-4">PSF Academy – Palanhaar sanatan foundation for Sanatan Values</h1>
              <p className="card-text mt-2">PSF Academy (Palanhaar sanatan foundation) is an institution dedicated to promoting the principles of Sanatan Dharma, Indian culture, and moral values.
It aims to guide youth and children towards the right path by connecting them with spirituality, ethics, and the true essence of life.</p>
              <hr />
            </div>

            {/* <div className=" col-12 col-sm-12 col-md-6">
              <img className='w-100 rounded-4 product-img-out' src={URL?.API_BASE_URL + item?.feature_image}    alt={item.feature_image}/>
            </div> */}
          </div>
                                                 
   

        {productLists && productLists.length > 0 ? (
            productLists.map((item, index) => (
           <div className='row d-flex align-items-center mx-1 mb-5'>
          {/* Left Side (Text Cards) */}
          <div className='col-lg-6 col-12'>
          
              <div
                className="p-4 mb-4 rounded-4 text-dark bg-light shadow-sm"
                key={index}
              >
                <div className="d-flex align-items-start">
                  <i className="fas fa-fan fs-2 me-3 text-danger"></i>
                  <div>
                    <h4 className="fw-bold">{item.title}</h4>
                    <p className="mb-0">{item.short_description}</p>
                  </div>

                </div>
              </div>
          
            <button className='btn btn-danger px-4' href="/about">Learn More</button>
          </div>

          <div className="col-lg-6 col-12 d-flex flex-column justify-content-between my-4">
            <img  className="w-100 rounded-4 mb-4 product-img-out" src={URL?.API_BASE_URL + item?.feature_image}    alt={item.feature_image}  style={{ objectFit: "cover" , maxHeight: "250px" }} />
         
          </div>
        </div>
                                             
       ))
            ) : (
            <p>Loading...</p>
            )}
        <hr />
    </div>
  )
}

export default Myservice